import { Observable, of } from 'rxjs';
import { catchError, filter, first, switchMap, tap } from 'rxjs/operators';

import { Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { SharedEntityFacadeInterface } from '@ideapa/app-common';
import { BaseDto } from '@ideapa/common-dto';

@Injectable()
export class BaseLoadAllGuard<T extends BaseDto> implements CanActivate {
  constructor(
    @Inject('SharedEntityFacade')
    private sharedFacade: SharedEntityFacadeInterface<T>
  ) {}

  canActivate(): Observable<boolean> {
    return this.checkLoaded().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkLoaded(): Observable<boolean> {
    return this.sharedFacade.loadedAll$.pipe(
      tap((loaded) => {
        if (!loaded) {
          this.sharedFacade.loadAll();
        }
      }),
      filter((loaded) => loaded),
      first()
    );
  }
}
